<!-- 图表图例 -->
<template>
  <div v-if="isShow" class="legend-box"
    :style="{ backgroundColor: isTouched ? '#fff4ef' : '#ffffff'}">
    <!-- 图例数据时间 -->
    <div v-if="!$isEmpty(chartTime)" class="legend-item legend-value">{{chartTime}}</div>
    <!-- 图例 -->
    <div v-for="(item, index) in legendConfigList" :key="index" class="legend-item">
      <div
        v-if="item.iconType === 'dot'"
        :style="{backgroundColor: item.color}"
        class="legend-dot"></div>
      <div
        v-if="item.iconType === 'line'"
        :style="{backgroundColor: item.color}"
        class="legend-dot"></div>
      <div class="legend-label">{{item.label+'：'}}</div>
      <div class="legend-value" :style="{color: item.fontColor}">{{
        item.value
      }}</div>
      <img
        v-if="!$isEmpty(item.iconUrl)"
        :src="item.iconUrl"
        @click="clickIcon(item)"
        class="legend-tip-icon"/>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';
import CHART_CONFIG from './chart-config';
import CONFIG from '../../configs/default';
import chartTool from '../../utils/chart';

const SHOW_TIME_LIST = ['perNetValue', 'accNetValue', 'trendOfGold', 'profitOf10000', 'timeSharing', 'kLine'];

export default {
  name: 'fund-chart-legend',

  props: {
    isTouched: {
      type: Boolean,
      default: false,
    },
    period: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    lineChartType: {
      type: String,
      default: '',
    },
    legendValueList: {
      type: Array,
      default: () => ([]),
    },
    indexName: {
      type: String,
      default: '',
    },
  },

  computed: {
    isShow() {
      return !(this.$isEmpty(this.lineChartType)
      || this.$isEmpty(this.legendValueList));
    },
    chartTime() {
      const isShowTime = SHOW_TIME_LIST.includes(this.lineChartType);
      const time = isShowTime ? this.legendValueList[0].date || '' : '';
      return time || '--';
    },
    legendConfigList() {
      const config = CHART_CONFIG.legendConfig[this.lineChartType] || [];
      const tmp = config?.map((item) => {
        const valueItem = this.legendValueList.find((i) => i.type === item.type) || {};
        let { label } = item;
        const { labelKey } = item;
        if (!this.$isEmpty(labelKey)) {
          label = this.getLabel(labelKey) || label;
        }
        return { ...item, ...valueItem, label };
      }) || [];
      const list = chartTool.formateLegendList(tmp);
      console.log('=====> real legendList', list);
      return list;
    },
  },

  methods: {
    getLabel(labelKey) {
      const getFunc = {
        periodText: () => {
          const { chartPeriodList } = CONFIG;
          const period = chartPeriodList?.find((item) => item.value === this.period) || {};
          const fundDays = tool.getDaysToNow(this.basicInfo?.establishDate);
          if (!this.$isEmpty(period.dayCount) && fundDays < period.dayCount) { // 成立日期小于图表周期
            return typeof (period.unableLabel) === 'function'
              ? period.unableLabel(this.basicInfo?.establishDate)
              : `成立来(${period.unableLabel})`;
          }
          return period.label;
        },
        indexName: () => (this.indexName),
      };
      return getFunc[labelKey] ? getFunc[labelKey]() : '';
    },

    // 点击图例图标
    clickIcon(item) {
      console.log(item);
      if (item.type === 'index-point') { // 指数弹窗
        this.$emit('clickIndexPoint');
      }
      if (item.type === 'bench-point' || item.type === 'type-point') {
        this.$emit('clickTipPoint', item);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.legend-box {
  width: 100%;
  padding: 24px 24px 0;
  // padding-top: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.legend-item {
  width: 50%;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  justify-content: left;
  align-items: center;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  margin-right: 8px;
}
.legend-line {
  width: 16px;
  height: 6px;
  border-radius: 6px;
  margin-right: 4px;
}
.legend-label {
  font-size: 24px;
  color: #666666;
  line-height: 24px;
}
.legend-value {
  font-size: 24px;
  line-height: 24px;
  font-family: DINAlternate-Bold;
}
.legend-tip-icon {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}

</style>
